import React from 'react'
import { ImArrowUp } from "react-icons/im";
import { useTranslation } from 'react-i18next';


export default function ScrollTop({scrollValue}) {
  const { t } = useTranslation();

  const handleScrollTop = () =>{
      window.scrollTo({
          top: 0, 
          behavior: 'smooth'
      });
  }
  return (
    <div className={scrollValue > 200 ? "scrollTop scrollTop-active" :"scrollTop"} onClick={handleScrollTop}>
    <div>
      <span >{t('common.back_to_top')}</span>
      <ImArrowUp/>
    </div>
  </div>
  )
}
